import { useDispatch, useSelector } from "react-redux";

import { AboutForm } from "./AboutForm";
import { CreateAbout } from "../../redux/about";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const AboutCreate = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.about);
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this`)) {
      dispatch(CreateAbout(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <AboutForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
